/** Shared availability impact filter label and dropdown options (complaints + devices). */
export const AVAILABILITY_IMPACT_FILTER_LABEL = 'Availability Impact';

export const AVAILABILITY_IMPACT_FILTER_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'yes', label: 'Yes — impacts availability' },
  { value: 'no', label: 'No — confirmed no impact' },
  { value: 'pending', label: 'Pending — not yet confirmed' },
];

/** Short labels for active-filter pills (matches dropdown intent). */
export const AVAILABILITY_IMPACT_ACTIVE_VALUE_LABELS = {
  yes: 'Yes',
  no: 'No',
  pending: 'Pending',
};

/**
 * Label for the active-filter pill, e.g. "Availability Impact: Yes".
 * Returns empty string when no specific value is selected (All).
 */
export const formatAvailabilityImpactActiveFilterLabel = (value) => {
  if (!value) return '';
  const valueLabel = AVAILABILITY_IMPACT_ACTIVE_VALUE_LABELS[value] || value;
  return `${AVAILABILITY_IMPACT_FILTER_LABEL}: ${valueLabel}`;
};

/** True when an active complaint is impacting this device's clinical availability. */
export const deviceHasAvailabilityImpact = (device) => {
  const value = device?.has_availability_impact;
  return value === true || value === 1 || value === '1' || value === 't' || value === 'true';
};
